import { EN_COMMON } from "./common/en";
import { Common } from "./common/type";
import { VI_COMMON } from "./common/vi";

type Locale = {
  common: Common;
};

export const EN: Locale = { common: EN_COMMON };
export const VI: Locale = { common: VI_COMMON };
